<template>
   <div class="container-fluid py-5">
      <div class="row justify-content-center">
         <div class="col-md-6 col-lg-5">

            <div class="card bg-sa-card shadow-lg border-0 rounded-4 text-center">
               <div class="card-body bg-sa-card-body p-5">

                  <div class="access-denied-icon mb-4">
                     <i class="fa fa-lock"></i>
                  </div>

                  <h1 class="sa-core-color mb-3">
                     Access Denied
                  </h1>

                  <p class="sa-core-color mb-4">
                     You do not have permission to access this page.
                  </p>

                  <p class="small sa-core-color mb-4">
                     If you believe you should have access, please contact your administrator.
                  </p>

                  <div class="d-flex justify-content-center gap-2 flex-wrap">
                     <button
                        type="button"
                        class="btn btn-primary"
                        @click="goBack"
                     >
                        <i class="fa fa-arrow-left me-1"></i>
                        Go Back
                     </button>

                     <button
                        type="button"
                        class="btn btn-secondary"
                        @click="goHome"
                     >
                        <i class="fa fa-home me-1"></i>
                        Dashboard
                     </button>
                  </div>

               </div>
            </div>

         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'AccessDenied',

   methods: {
      goBack() {
         this.$router.back();
      },

      goHome() {
         this.$router.push('/dashboard/');
      }
   }
};
</script>